// custom elements
import '@adornis/digitale-helden-shared/client/theme';
// defaults
import '@adornis/chemistry/elements/components/stack/x-stack.js';
import '@adornis/chemistry/elements/components/x-flex.js';
import '@adornis/chemistry/elements/components/x-grid.js';
import '@adornis/chemistry/elements/components/x-loader.js';
import '@adornis/chemistry/elements/components/x-section.js';
import '@adornis/dragdrop/x-drag-drop.js';
import '@adornis/file-utils/client/x-image.js';
import '@adornis/popover/x-dropdown-selection.js';
import '@adornis/redirect/client/x-redirect.js';
import '@adornis/tiptap/client/x-tiptap.js';
import '@adornis/user-forms/x-login-input.js';
import '@adornis/user-forms/x-login.js';
// others
import { createComponentsFromChemistryBase } from '@adornis/chemistry/elements/x-components.js';
import '../buildify/index.js';
import '../index.js';
import { dialogDefaultComponents } from './dialog.js';

// headings
import '../d-h1.js';
import '../d-h2.js';
import '../d-h3.js';
import '../d-h4.js';
import '../d-link.js';
import '../d-text.js';

// redirect
import '@adornis/digitale-helden-shared/client/theme/redirect/d-redirect.js';

// dataview
import '@adornis/data-view/client/x-data-view-table.js';
import '@adornis/data-view/client/x-data-view.js';

createComponentsFromChemistryBase(
  // login
  'x-login',
  'x-login-input',
  // defaults
  'x-loader',
  'x-flex',
  'x-grid',
  'x-drag-drop',
  'x-image',
  'x-tiptap',
  'x-tiptap-action-bar',
  'x-dropdown-selection-content',
  'x-stack',
  'x-stack-breadcrumb',
  // others
  ...dialogDefaultComponents,

  // dataview
  'x-data-view',
  'x-data-view-table',
);
